export default __webpack_public_path__ + "static/media/larplogo.181867b4.jpeg";